import { DataKind, Resource } from "../../types";

// Partial is used here because not all resources have DataKind defined for them.
// For better type safety once we have DataKinds defined for all resources,
// we should remove the Partial and enforce that every Resource has a corresponding DataKind.
export const DATA_KIND_FOR_RESOURCE: Partial<Record<Resource, DataKind>> = {
  [Resource.Account]: DataKind.Account,
  [Resource.AccountOverageNotification]: DataKind.AccountOverageNotification,
  [Resource.AccountRegion]: DataKind.AccountRegion,
  [Resource.AccountUserCount]: DataKind.AccountUserCount,
  [Resource.ActiveUserCount]: DataKind.ActiveUserCount,
  [Resource.AdminRoleMembership]: DataKind.AdminRoleMembership,
  [Resource.AdminUser]: DataKind.AdminUser,
  [Resource.ApiKey]: DataKind.ApiKey,
  [Resource.AuditLogProject]: DataKind.AuditLogProject,
  [Resource.BoxToken]: DataKind.BoxToken,
  [Resource.CanceledEnterpriseOwner]: DataKind.CanceledEnterpriseOwner,
  [Resource.CanceledInAppPurchaseUser]: DataKind.CanceledInAppPurchaseUser,
  [Resource.CanceledStripeOwner]: DataKind.CanceledStripeOwner,
  [Resource.Charge]: DataKind.Charge,
  [Resource.Company]: DataKind.Company,
  [Resource.ConfigVariable]: DataKind.ConfigVariable,
  [Resource.DemoProjectTemplate]: DataKind.DemoProjectTemplate,
  [Resource.DemoProjectUser]: DataKind.DemoProjectUser,
  [Resource.DropboxToken]: DataKind.DropboxToken,
  [Resource.EnterprisePlan]: DataKind.EnterprisePlan,
  [Resource.EnterprisePlanInvoice]: DataKind.EnterprisePlanInvoice,
  [Resource.FeatureFlag]: DataKind.FeatureFlag,
  [Resource.InAppPurchase]: DataKind.InAppPurchase,
  [Resource.JobInfo]: DataKind.JobInfo,
  [Resource.ManualWorker]: DataKind.ManualWorker,
  [Resource.MicrosoftToken]: DataKind.MicrosoftToken,
  [Resource.OtcMaintenanceWindow]: DataKind.OtcMaintenanceWindow,
  [Resource.PayingEnterpriseOwner]: DataKind.PayingEnterpriseOwner,
  [Resource.PayingInAppPurchaseUser]: DataKind.PayingInAppPurchaseUser,
  [Resource.PayingStripeOwner]: DataKind.PayingStripeOwner,
  [Resource.Project]: DataKind.Project,
  [Resource.ProjectsUser]: DataKind.ProjectsUser,
  [Resource.SsoInfo]: DataKind.SsoInfo,
  [Resource.StressTestingProject]: DataKind.StressTestingProject,
  [Resource.StripeSubscription]: DataKind.StripeSubscription,
  [Resource.SyncError]: DataKind.SyncError,
  [Resource.User]: DataKind.User,
};

export const getDataKind = (resource: Resource) =>
  DATA_KIND_FOR_RESOURCE[resource];
